import styled from 'styled-components';
import { space } from 'styled-system';
import TypographyStyles from '../base/typographyStyles';

const ProductWrapperStyles = styled.div`
  padding-left: ${props => props.theme.space[1]};
  padding-right: ${props => props.theme.space[1]};
  width: 50%;
  margin-bottom: ${props => props.theme.space[2]};
`;

const ProductListStyles = styled.div`
  margin-top: ${props => props.theme.space[2]};
  margin-left: -${props => props.theme.space[1]};
  margin-right: -${props => props.theme.space[1]};
  display: flex;
  flex-wrap: wrap;
`;

const ProductImageStyles = styled.div`
  overflow: hidden;
`;

const ProductStyles = styled.div`
  ${space}

  border: 0.0625rem solid ${props => props.theme.colors.inputBorder};
  position: relative;
  height: 100%;

  &:hover {
    ${TypographyStyles.ImageStyles} {
      transform: scale(1.2);
    }
  }
`;

const ProductContentStyles = styled.div`
  padding: ${props => props.theme.space[2]};
  position: relative;
`;

const ProductDataStyles = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

ProductStyles.WrapperStyles = ProductWrapperStyles;
ProductStyles.ListStyles = ProductListStyles;
ProductStyles.ImageStyles = ProductImageStyles;
ProductStyles.ContentStyles = ProductContentStyles;
ProductStyles.DataStyles = ProductDataStyles;

export default ProductStyles;
